import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { IFRDedicats } from './dedicats.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DedicatsService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(id, codi, tipus): Observable<IFRDedicats[]> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(this._API_BASE_URL + 'dedicacions/' + id + "/" + codi+ "?tipus="+tipus, this.options)
      .pipe(map(response => response || []));
  }

  public getDedicacionsMes(id, year, tipus): Observable<any[]> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(this._API_BASE_URL + 'dedicacionsmes/' + id + "/" + year+ "?tipus="+tipus, this.options)
      .pipe(map(response => {return response || []}));
  }

  public updateDedicacionsMes(data, id: string, year: string, tipus: number): Observable<any> {
    return this.authHttp.put(this._API_BASE_URL + 'dedicacionsmes/'+id+"?tipus="+tipus+"&year="+year, data)
      .pipe(map(response => response || {}));
  }

  public getHoresFetes(id, codi, tipus, inici, fi): Observable<number> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(this._API_BASE_URL + 'dedicacionshores/' + id + "/" + codi + "?tipus="+tipus+"&inici="+inici+"&fi="+fi, 
      this.options).pipe(map(response => response || []));
  }

  public update(op: any, data): Observable<any> {
    if(op == 'NEW')//create
      return this.authHttp.post(this._API_BASE_URL + 'dedicacions/'+data.id, data)
      .pipe(map(response => response || {}));
    else //update
      return this.authHttp.put(this._API_BASE_URL + 'dedicacions/'+data.id, data)
      .pipe(map(response => response || {}));
  }
  
  public delete(id): Observable<any> {
    return this.authHttp.delete(this._API_BASE_URL + 'dedicacions/'+id)
      .pipe(map(response => response || {}));
  }
  
  public getCodis(id, tipus): Observable<any> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'dedicacions/codis/' + id +'/' + tipus, this.options)
      .pipe(map(response => response || []));
  }
  
  public getHoresProj(id, tipus, inici, fi): Observable<any> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'dedicacions/horesproj/' + id +'/' + tipus+ "?inici="+inici+"&fi="+fi, this.options)
      .pipe(map(response => response || []));
  }
  constructor(private authHttp: HttpClient) { }
}
